module.exports = __webpack_public_path__ + "media/components/src/assets/images/embellishments/gifts/gift_blue_03-b8ba6e62f10cf65411cd20ea26e5d93e.svg";